/**
 * Presety zakresów dat dla raportów (Faza 13). Wszystko w lokalnej
 * strefie procesu (Europe/Warsaw — backend i tak interpretuje
 * "YYYY-MM-DD" lokalnie). Domyślny preset to `thisMonth`.
 */

export type PresetId = 'thisMonth' | 'last7Days' | 'last30Days' | 'thisQuarter' | 'custom';

function pad(n: number): string {
  return String(n).padStart(2, '0');
}

function toIso(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export type Range = { from: string; to: string };

export function presetRange(id: PresetId, today: Date = new Date()): Range {
  const t = new Date(today);
  t.setHours(0, 0, 0, 0);

  if (id === 'thisMonth') {
    const from = new Date(t.getFullYear(), t.getMonth(), 1);
    return { from: toIso(from), to: toIso(t) };
  }
  if (id === 'last7Days') {
    const from = new Date(t);
    from.setDate(from.getDate() - 6); // włącznie z dziś = 7 dni
    return { from: toIso(from), to: toIso(t) };
  }
  if (id === 'last30Days') {
    const from = new Date(t);
    from.setDate(from.getDate() - 29);
    return { from: toIso(from), to: toIso(t) };
  }
  if (id === 'thisQuarter') {
    const q = Math.floor(t.getMonth() / 3); // 0..3
    const from = new Date(t.getFullYear(), q * 3, 1);
    return { from: toIso(from), to: toIso(t) };
  }
  // 'custom' — fallback na thisMonth (UI nigdy tego nie wywołuje, ale safety).
  const from = new Date(t.getFullYear(), t.getMonth(), 1);
  return { from: toIso(from), to: toIso(t) };
}
